module.exports = __webpack_public_path__ + "static/media/tela-sala-virtual-manutencao.f5135a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tela-sala-virtual-manutencao.jpg
// module id = 1059
// module chunks = 0